import { makeStyles } from '@mui/styles';

// colors
import { colors } from '../../../../colors';

export const useStyles = makeStyles({
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
  },
  container: {
    padding: '16px',
    display: 'flex',
    width: '100%',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  rightActions: () => ({
    gap: 16,
    display: 'flex',
    alignItems: 'center',
  }),
  finishLaterBtn: {
    fontSize: '12px',
    color: colors.neutral600,
    fontWeight: 600,
  },
  progressBar: {
    borderTop: `1px solid ${colors.neutral100}`,
    // borderBottom: `1px solid ${colors.neutral100}`,
    height: '6px !important',
    backgroundColor: colors.neutral50,
    borderRadius: '0px !important',
    '& .MuiLinearProgress-bar': {
      borderRadius: '0px !important',
      backgroundColor: colors.primary500,
    },
  },
  backBtn: {
    border: 'none',
    backgroundColor: colors.primary100,
    width: 40,
    height: 40,
    padding: 0,
    minWidth: 0,
  },
  leftActions: {
    display: 'flex',
    flexDirection: 'row',
    gap: 16,
    alignItems: 'center',
  },
  headerTitle: {
    fontWeight: 600,
    color: colors.neutral900,
    fontSize: 16,
    lineHeight: '24px',
  },
  headerSubtitle: {
    fontWeight: 500,
    color: colors.neutral600,
    fontSize: 14,
    lineHeight: '20px',
  }
});
